import { createCoreMethod } from '../../utils/createCoreMethod';

export const getPageAndFileData = createCoreMethod(
  'getPageAndFileData',
  async () => {
    const key = `av-file-id${
      ['local', 'dev'].includes(import.meta.env.VITE_ENV)
        ? `-${import.meta.env.VITE_ENV}`
        : ''
    }`;

    return {
      pageName: figma.currentPage.name,
      fileId: figma.root.getPluginData(key),
      fileName: figma.root.name,
    };
  }
);
